// Helper bersama halaman laporan (Prompt F): export CSV + cetak.
// CSV: BOM \uFEFF supaya Excel baca UTF-8 dengan betul; nilai di-quote.
export function toCsv(rows, columns) {
  const esc = (v) => {
    const s = v === null || v === undefined ? '' : String(v);
    return `"${s.replace(/"/g, '""')}"`;
  };
  const head = columns.map((c) => esc(c.label)).join(',');
  const body = rows.map((r) => columns.map((c) => esc(typeof c.get === 'function' ? c.get(r) : r[c.key])).join(','));
  return '\uFEFF' + [head, ...body].join('\r\n');
}

export function downloadCsv(filename, csv) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export function printLaporan(judul) {
  document.title = judul;
  window.print();
}

// Bucket umur tunggakan dari due_date tertua (hari)
export function agingBucket(dueDate) {
  if (!dueDate) return '90+';
  const days = Math.floor((Date.now() - new Date(dueDate).getTime()) / 86400000);
  if (days <= 30) return '1-30';
  if (days <= 60) return '31-60';
  if (days <= 90) return '61-90';
  return '90+';
}

export const todayStr = () => new Date().toISOString().slice(0, 10);
export const monthStartStr = () => new Date().toISOString().slice(0, 7) + '-01';
